import { useQuery } from "@apollo/client";
import { QR_LIST_TRIP_PUBLICATION_SUMMARY } from "../graphQl/TripsAPI";

/* Référence stable quand l'API ne renvoie rien. Un `|| []` créait un nouveau
   tableau à chaque rendu : GridCard et ListCard l'ont en dépendance d'un
   useEffect qui fait un setState, d'où une boucle de rendus infinie
   (« Maximum update depth exceeded ») dès qu'une recherche ne donne aucun
   résultat. Tant que la boucle tourne, les navigations en startTransition
   (clic sur le logo) ne sont jamais appliquées. */
const EMPTY_PUBLICATIONS = Object.freeze([]);

export const useTripPublicationSummaryList = (params) => {
  const {
    currentPage = 1,
    elementsPerPage = 6,
    establishmentIds,
    publicationIds,
    destination,
    startDate,
    endDate,
    adultTravelers,
    childTravelers,
    babiesTravelers,
    maxPrice,
    minPrice,
  } = params;

  /**
   * 🔧 Convertisseur de date sécurisé
   */
  const safeDate = (d) => {
    if (!d) return undefined;
    const parsed = new Date(d);
    return isNaN(parsed.getTime())
      ? undefined
      : parsed.toISOString().substring(0, 10);
  };

  /**
   * 🔧 Supprime les champs invalides (null, undefined, "")
   */
  const clean = (obj) =>
    Object.fromEntries(
      Object.entries(obj).filter(
        ([, v]) => v !== null && v !== undefined && v !== "" && !Number.isNaN(v)
      )
    );

  // 🔥 Nettoyage final des variables envoyées à Apollo
  const variables = clean({
    paginationParams: {
      currentPage: currentPage - 1,
      sizePage: elementsPerPage,
    },
    establishmentIds,
    publicationIds,
    destination,
    startDate: safeDate(startDate),
    endDate: safeDate(endDate),
    adultTravelers,
    childTravelers,
    babiesTravelers,
    maxPrice,
    minPrice,
  });

  const { data, loading, error, refetch } = useQuery(
    QR_LIST_TRIP_PUBLICATION_SUMMARY,
    {
      variables,
      fetchPolicy: "cache-and-network",
    }
  );

  const publications =
    data?.QR_LIST_TRIP_PUBLICATION_SUMMARY?.data?.content || EMPTY_PUBLICATIONS;
  const totalPages =
    data?.QR_LIST_TRIP_PUBLICATION_SUMMARY?.data?.totalPages || 1;
  const totalElements =
    data?.QR_LIST_TRIP_PUBLICATION_SUMMARY?.data?.totalElements || 0;
  const current =
    data?.QR_LIST_TRIP_PUBLICATION_SUMMARY?.data?.currentPage || 0;

  return {
    publications,
    totalPages,
    totalElements,
    currentPage: current + 1,
    loading,
    error,
    refetch: (newParams) =>
      refetch(
        clean({
          ...variables,
          ...newParams,
          startDate: safeDate(newParams?.startDate),
          endDate: safeDate(newParams?.endDate),
        })
      ),
  };
};
